import Vue from 'vue'
import Router from 'vue-router'
import Vuex from 'vuex'
import firebase from 'firebase'

Vue.use(Vuex)
Vue.use(Router)

export default new Vuex.Store({
    state    : {
        loggedIn       : false,
        uid            : '',
        admin          : null,
        showPageSpinner: false,
        user           : null,
        userAccount    : null,
        userRole       : null
    },
    getters  : {
        getLoggedIn   : state => state.loggedIn,
        getUid        : state => state.uid,
        getUser       : state => state.user,
        getUserAccount: state => state.userAccount,
        getUserRole: state => state.userRole
    },
    mutations: {
        setUser         : (state, payload) => {
            state.user = payload
            console.log('setUser committed...')
        },
        setUserAccount  : (state, payload) => {
            state.userAccount = payload
            // console.log('userAccount committed...')
        },
        setUserRole  : (state, payload) => {
            state.userRole = payload
            // console.log('userRole committed...')
        },
        clearUser       : (state) => {
            state.profile = null
            console.log('clearUser committed...')
        },
        clearUserAccount: (state) => {
            state.userAccount = {}
            // console.log('clearUserAccount committed...')
        },
        setLoggedIn     : (state) => {
            state.loggedIn = {}
            // console.log('setLoggedIn committed...')
        }
    },
    actions  : {
        login         : (context, userDetails) => {
            // console.log('login dispatch received...')
            // console.log(userDetails);
            let email    = userDetails.email
            let password = userDetails.password
            // console.log(context);
            if (email && password) {
                firebase.auth().signInWithEmailAndPassword(email, password)
                    .then(response => {
                        // handle successful login
                        // console.log('successful login with firebase...');
                        context.commit('setUser', response.user)
                        context.dispatch('getUserAccount')
                    })
                    .catch(function (error) {
                        // Handle Errors here.
                        var errorCode    = error.code;
                        var errorMessage = error.message;
                        if (errorMessage) {
                            alert('coming from login action in store :: ' + errorCode + ' - ' + errorMessage)
                        }
                    });
            }

        },
        getUserAccount: (context) => {
            // console.log('getUserAccount dispatch received...')

            // let self = this
            // let user = auth.currentUser;

            auth.onAuthStateChanged(function (user) {
                if (user) {
                    // User is signed in.
                    let displayName   = user.displayName;
                    let email         = user.email;
                    let emailVerified = user.emailVerified;
                    let photoURL      = user.photoURL;
                    let isAnonymous   = user.isAnonymous;
                    let uid           = user.uid;
                    let providerData  = user.providerData;
                    // console.log('coming from getUserAccount action' + JSON.stringify(user));
                    context.commit('setUser', user)

                    user.getIdTokenResult().then(idTokenResult => {
                        if ( idTokenResult.claims.role ) {
                            context.commit('setUserRole', idTokenResult.claims.role)
                        }
                        console.log(idTokenResult.claims.role);
                    })

                    db.collection('users').doc(uid).get()
                        .then(doc => {
                            context.commit('setUserAccount', doc.data())
                            // console.log('set user account with :: ' + JSON.stringify(doc.data()));
                        })
                } else {
                    // context.$router.push({path: '/'})
                    // console.log('Sorry, you\'re not an admin. Nice try ;)...');
                }
            })

        },
        logout        : (context, routeObj, notify) => {
            // console.log('logout dispatch received...')
            let self = this
            firebase.auth().signOut()
                .then(function () {
                    // Sign-out successful.
                    context.commit('setLoggedIn', false)
                    context.commit('clearUserAccount')
                    context.commit('clearUser')
                    context.commit('setUserRole', null)
                    // context.$router.push({path: '/'})

                })
                .catch(function (error) {
                    // An error happened
                    context.commit('setLoggedIn', false)
                    context.commit('clearUserAccount')
                    context.commit('clearUser')
                    context.commit('setUserRole', null)
                    alert(error)
                    // context.$router.push({path: '/'})
                });
        },
        register      : (context, userDetails) => {
            // console.log('register dispatch received...')
            let self     = this
            let email    = userDetails.email
            // console.log(email);
            let password = userDetails.password
            // console.log(password);
            let name     = userDetails.name
            // console.log(name);
            let country  = userDetails.country
            // console.log(country);
            firebase.auth().createUserWithEmailAndPassword(email, password)
                .then(cred => {
                    return firebase.firestore().collection('users').doc(cred.user.uid).set({
                        driver     : false,
                        admin      : false,
                        industry   : false,
                        permissions: 9,
                        country    : country,
                        email      : email,
                        name       : name
                    })
                })
                .then(() => {
                    console.log('firebase user account created successfully...');
                })
                .catch(function (error) {
                    // Handle Errors here.
                    var errorCode    = error.code;
                    var errorMessage = error.message;
                    if (errorMessage) {
                        alert(errorMessage)
                    } else {
                        // self.$router.push({path: '/success'})
                    }
                });
        }
    }
})
